import React, { useEffect, useState } from 'react';

import Heading from '@/src/shared/components/Heading';
import Loading from '@/src/shared/components/LoadingResults';
import { form as formStyle } from '@/styles';
import request from '@/utils/axios';

import DescriptionRow from './DescriptionRow';

const PublicationDescriptions = () => {
  const [isLoading, setLoading] = useState(true);
  const [descriptions, setDescriptions] = useState([]);

  useEffect(() => {
    request({
      url: `cms/informationofferings?type=general`,
      triggerLoad: false,
    }).then(response => {
      const {
        data: { Offerings },
      } = response;
      setDescriptions(Offerings);
      setLoading(false);
    });
  }, []);

  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div css={formStyle.gridRow}>
            <Heading type={3} weight="bolder" theme="gray">
              Title
            </Heading>
            <Heading type={3} weight="bolder" theme="gray">
              Description
            </Heading>
          </div>
          {descriptions.map(pub => (
            <DescriptionRow publication={pub} key={pub.PublicationCode} />
          ))}
        </>
      )}
    </div>
  );
};

export default PublicationDescriptions;
